import React from 'react';
import { Icon } from '@packages/ui/shared';

type SpecialTool = {
    question: string;
    answer: React.ReactNode;
};

const specialToolsData: SpecialTool[] = [
    {
        question: 'Does Subaru have a manufacturer-specific Diagnostic Interface tool?',
        answer: (
            <>
                Yes. Subaru offers an OEM diagnostic interface tool for use in certain system diagnostics and
                reprogramming.
            </>
        ),
    },
    {
        question: 'What is the availability of the Subaru OEM Diagnostic Interface tool?',
        answer: (
            <>
                Subaru offers an OEM diagnostic interface tool and diagnostic software to authorized Subaru Dealers,
                independent repair facilities and individuals.
            </>
        ),
    },
    {
        question: 'What is the process for obtaining a Subaru OEM Diagnostic Interface tool?',
        answer: (
            <>
                <strong>Note:</strong> Subaru Diagnostic Interface tool is ONLY offered for the US market.
                <br />
                <br />
                <strong>3a)</strong> Authorized Subaru Dealerships can order a Subaru Diagnostic Interface tool through
                the Subaru DT web site:{' '}
                <a href="http://www.subarudt.com/" target="_blank" rel="noopener noreferrer">
                    www.subarudt.com
                </a>
                . (Available for purchase only)
                <br />
                <br />
                <strong>3b)</strong> Independent repair facilities and individuals can order a Subaru Diagnostic
                Interface tool and diagnostic software through Nuspire Networks.
                <br />
                <br />
                The DENSO DST-i interface is compatible with 2004 and newer Subaru Vehicles. The Subaru Select Monitor
                diagnostic software is compatible with 2002 and newer Subaru Vehicles. Both components are available
                separately for purchase only.
                <br />
                <br />
                To order, visit{' '}
                <a href="https://security.pditechnologies.com/subaru-tech/" target="_blank" rel="noopener noreferrer">
                    security.pditechnologies.com/subaru-tech/
                </a>{' '}
                and fill out the required information. For any questions contact PDI Technologies at the telephone
                number below Mon-Fri 8:30 AM to 5:30 PM EST.
                <br />
                <br />
                PDI Technologies
                <br />
                11675 Rainwater Dr
                <br />
                Alpharetta, GA 30009
                <br />
                Tel: <a href="tel:1-254-410-7600">Tel: (254) 410-7600</a>
                <br />
                Site:{' '}
                <a href="https://security.pditechnologies.com/subaru-tech/" target="_blank" rel="noopener noreferrer">
                    Visit Subaru Tech
                </a>
                <br />
                <em>
                    User Note: This type of electronic device requires the advanced automotive knowledge that only a
                    trained technician possesses. Subaru does not offer technical support for diagnostic tools that are
                    not sold by Subaru and will not answer specific questions based on the operation or performance of
                    these devices. All questions pertaining to this device should be directed to PDI Technologies at the
                    above contact information.
                </em>
            </>
        ),
    },
    {
        question: 'What are J2534 reprogramming capabilities available?',
        answer: (
            <>
                <strong>(4a) J2534 Reprogramming</strong>
                <br />
                Subaru reprogramming files using a generic (non-OEM) SAEJ2534 pass-thru vehicle programming device are
                available by contacting <strong>Service Technical Information Company</strong> <u>toll-free</u> at{' '}
                <strong>1-866-428-2278</strong>. The cost for the CD-ROM with all reprogramming files is{' '}
                <strong>$75.00</strong> plus S/H and applicable state tax. Files will be updated four (4) times per
                year, in CD-ROM format, with all available reprogramming service information at the same above offered
                cost. Authorized Subaru Dealers are provided the same reprogramming information.
                <br />
                <br />
                Before purchasing, the reprogramming details can be found in the following{' '}
                <a
                    href="https://www.subarunet.com/stis/doc/otherMisc/Reprogramming_Pre-J2534_Files.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Reprogramming J-2534 Files chart
                </a>
                . Click the link to view the PDF chart.
                <br />
                <br />
                Subaru J2534 Reprogramming software meets the latest available J2534-1 specification. Our Reprogramming
                J2534 Files chart does not specify the Calibration Identification Number (CID); however, this
                information is included in our offered CD-ROM.
                <br />
                <br />
                <strong>Note:</strong> The ECM or TCM being reprogrammed may already contain some or all of the
                reprogramming files listed in the Reprogramming J2534 Files chart shown by release date. It is possible
                to damage the vehicles ECM/TCM during the reprogramming event. Once the reprogramming process has
                started, it is recommended not to interrupt the process until the event is completed. If you experience
                any problems, please contact your scan tool maker for further instructions.
                <br />
                <br />
                <strong>(4b) Are all pre-2004MY Subaru vehicles compatible with J2534?</strong>
                <br />
                <br />
                No. Subaru has no reprogramming capability for model years 1996-1998. Starting with our 1999 model year,
                please see our{' '}
                <a
                    href="https://www.subarunet.com/stis/doc/otherMisc/Reprogramming_Pre-J2534_Files.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Reprogramming Pre-J2534 Files
                </a>{' '}
                chart for affected model reprogramming information.
                <br />
                <br />
                Both pre-J2534 reprogramming and J2534 pass-thru reprogramming files are included in the offered HDS kit
                software for aftermarket service provider application.
            </>
        ),
    },
    {
        question: 'What are the Minimum Computer Operating Requirements?',
        answer: (
            <div>
                <table
                    style={{ width: 526, margin: '0 auto', border: '1px solid #000', borderCollapse: 'collapse' }}
                    cellSpacing={0}
                    cellPadding={6}
                >
                    <tbody>
                        <tr>
                            <td style={{ width: 175, textAlign: 'center', border: '1px solid #000' }}>
                                <strong>Operating System</strong>
                            </td>
                            <td style={{ width: 336, textAlign: 'center', border: '1px solid #000' }}>
                                <strong>
                                    <u>Windows</u>
                                </strong>
                                <br />
                                10 (32-bit or 64-bit)
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: 175, textAlign: 'center', border: '1px solid #000' }}>
                                <strong>CPU</strong>
                            </td>
                            <td style={{ width: 336, textAlign: 'center', border: '1px solid #000' }}>
                                Core i5 Series or higher
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: 175, textAlign: 'center', border: '1px solid #000' }}>
                                <strong>Memory</strong>
                            </td>
                            <td style={{ width: 336, textAlign: 'center', border: '1px solid #000' }}>
                                10 (32-bit): At least 1 GB
                                <br />
                                10 (64-bit): At least 2 GB
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: 175, textAlign: 'center', border: '1px solid #000' }}>
                                <strong>Hard Drive</strong>
                            </td>
                            <td style={{ width: 336, textAlign: 'center', border: '1px solid #000' }}>
                                At least 512GB
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: 175, textAlign: 'center', border: '1px solid #000' }}>
                                <strong>USB</strong>
                            </td>
                            <td style={{ width: 336, textAlign: 'center', border: '1px solid #000' }}>
                                USB 2.0 (at least 1 available port)
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: 175, textAlign: 'center', border: '1px solid #000' }}>
                                <strong>Display</strong>
                            </td>
                            <td style={{ width: 336, textAlign: 'center', border: '1px solid #000' }}>
                                Minimum: 1024x768 pixels
                                <br />
                                Recommended: 1920x1080 pixels
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: 175, textAlign: 'center', border: '1px solid #000' }} colSpan={2}>
                                <em>
                                    <strong>*Not guaranteed to operate on all computers.</strong>
                                </em>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        ),
    },
];

type FAQItemProps = {
    question: string;
    answer: React.ReactNode;
    open: boolean;
    onClick: () => void;
};

const SpecialToolItem: React.FC<FAQItemProps> = ({ question, answer, open, onClick }) => (
    <div
        style={{
            width: '100%',
            gap: 8,
            padding: 8,
            borderRadius: 8,
            marginBottom: 16,
            cursor: 'pointer',
            border: '1px solid #E3E3E3',
            display: 'flex',
            flexDirection: 'column',
        }}
    >
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                width: '100%',
                height: 45,
                padding: 8,
                cursor: 'pointer',
            }}
            onClick={onClick}
        >
            <Icon name={open ? 'chevron-down' : 'chevron-right'} color="blueOne" />
            <span
                style={{
                    fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
                    fontWeight: 600,
                    fontSize: 18,
                    lineHeight: '160%',
                    letterSpacing: 0,
                    color: '#1F518F',
                }}
            >
                {question}
            </span>
        </div>
        {open && (
            <div
                style={{
                    width: 'calc(100% - 40px)',
                    minHeight: 70,
                    paddingLeft: 40,
                    paddingRight: 8,
                    gap: 16,
                    fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
                    fontWeight: 400,
                    fontSize: 15,
                    lineHeight: '160%',
                    letterSpacing: 0,
                    color: '#4C525D',
                    marginTop: 8,
                }}
            >
                {answer}
            </div>
        )}
    </div>
);

export const SpecialTools: React.FC = () => {
    const [openIndex, setOpenIndex] = React.useState<number | null>(null);

    return (
        <div
            data-testid="special-tools"
            style={{
                maxWidth: '90%',
                margin: '0 auto',
                padding: '2rem',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: 15,
                color: '#000',
                background: '#fff',
            }}
        >
            <h1
                style={{
                    color: '#000',
                    fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
                    fontWeight: 400,
                    fontSize: 35,
                    lineHeight: '56px',
                    letterSpacing: '0%',
                }}
            >
                Diagnostic Tool Information
            </h1>
            <h2
                style={{
                    color: '#000',
                    fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
                    fontWeight: 700,
                    fontSize: 18,
                    lineHeight: '28px',
                    marginBottom: 16,
                }}
            >
                Special Tool Information
            </h2>
            <div
                style={{
                    marginBottom: 32,
                    fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
                    fontSize: 16,
                    color: '#222',
                    lineHeight: '160%',
                }}
            >
                Subaru "manufacturer specific" Diagnostic Scan Tools, along with the related hardware and software,
                provide the functionality required to troubleshoot self-diagnostic, computerized systems on 1996 model
                and later Subaru vehicles. These tools, which are made available to all Subaru franchised dealers, are
                available for purchase to all aftermarket service providers as well as equipment and tool companies for
                the proper service repair of Subaru vehicles through contracted&nbsp;third-party tool manufacturers, as
                referred to below.
                <br />
                <br />
                Subaru is committed to making available to information providers and tool companies training
                information, tools, and tool information. Although different manufacturers use different mediums for
                distributing tool information, Subaru's current practice is to distribute our information using NASTF
                (National Automotive Service Task Force), and Nuspire Networks. Tool information is distributed subject
                to reasonable confidentiality, licensing, and/or security arrangements.
                <br />
                <br />
                The following are some common questions that have been asked of us and our responses, so we present them
                here for your convenience:
                <br />
                <br />
                <strong>
                    NOTE: Subaru Diagnostic Scan Tools are ONLY for the United States of America market (US).
                </strong>
            </div>
            <div>
                {specialToolsData.map((faq, idx) => (
                    <SpecialToolItem
                        key={faq.question}
                        question={faq.question}
                        answer={faq.answer}
                        open={openIndex === idx}
                        onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                    />
                ))}
            </div>
        </div>
    );
};
